module.exports = __webpack_public_path__ + "static/img/3.44f85195.png";